@if (isAdmin()) {
    <aside
        class="sidebar"
        [class.sidebar-mobile]="sidebarService.isBelowTabletWidth()"
        [class.sidebar-wider]="sidebarService.isBelowTabletWidth()"
        [class.sidebar-hidden]="!sidebarService.isAdminSidebarEnabled()"
        [class.sidebar-fullscreen]="sidebarService.isBelowMobileWidth() && sidebarService.isAdminSidebarEnabled()"
    >
        <section>
            <div class="sidebar-header">
                <img src="assets/icons/admin-filled.svg" alt="Burger Icon" />
                <img src="assets/icons/close-nav-cross.svg" alt="Burger Icon" class="sidebar-header-close" (click)="sidebarService.disableAdminSidebar()" />
            </div>

            <nav class="nav">
                <div class="nav-title"><strong>Admin</strong></div>
                <a role="button" class="nav-link" id="nav-support" [routerLink]="['/admin/support']">
                    <img src="assets/icons/nav-icons-black/support.svg" alt="transactions icon" />
                    <span>{{ "navbar.settings_support_tool" | translate }}</span>
                </a>

                <a role="button" class="nav-link" id="nav-monitor-health" [routerLink]="['/admin/monitor-health']">
                    <img src="assets/icons/nav-icons-black/health-monitor.svg" alt="health-monitor icon" />
                    <span>{{ "operator.filter_bar.anton-health" | translate }}</span>
                </a>

                <a role="button" class="nav-link" id="nav-discount-tool" [routerLink]="['/admin/discount-tool']">
                    <img src="assets/icons/nav-icons-black/discount.svg" alt="discount icon" />
                    <span>{{ "discount_tool.discount_tool" | translate }}</span>
                </a>
            </nav>

            <div class="control-input">
                <input type="text" class="form-control control-input-field" #controlledInput placeholder="Control..." (keyup.enter)="enterControlledState(controlledInput.value)" />
                <div class="control-input-append" (click)="enterControlledState(controlledInput.value)">
                    <img src="assets/icons/admin-white.svg" alt="Admin logo" />
                </div>
            </div>

            <div class="info">
                @if (adminService.loadingControlledUid()) {
                    <app-loading-indicator size="small" color="secondary" />
                } @else if (adminService.controlActive() && controlledUser) {
                    <h4 class="info-header">User:</h4>

                    <!-- User UID -->
                    <div class="info-box">
                        <p><strong>UID:</strong></p>
                        <div class="info-box-value">
                            <p [id]="authenticatedUser.uid + '-user'">{{ authenticatedUser.uid }}</p>
                            <img src="assets/icons/copy-icon.svg" class="info-box-value-copy" alt="copy" (click)="helperService.copySomeText(authenticatedUser.uid, authenticatedUser.uid + '-user')" />
                        </div>
                    </div>

                    <!-- User Role -->
                    <div class="info-box">
                        <p><strong>Role:</strong></p>
                        <div class="info-box-value">
                            <p [id]="authenticatedUser.role">{{ authenticatedUser.role }}</p>
                            <img src="assets/icons/copy-icon.svg" class="info-box-value-copy" alt="copy" (click)="helperService.copySomeText(authenticatedUser.role.toString(), authenticatedUser.role.toString())" />
                        </div>
                    </div>

                    <!-- User Email -->
                    <div class="info-box">
                        <p><strong>Email:</strong></p>
                        <div class="info-box-value">
                            <p [id]="authenticatedUser.email + '-user'">{{ authenticatedUser.email }}</p>
                            <img src="assets/icons/copy-icon.svg" class="info-box-value-copy" alt="copy" (click)="helperService.copySomeText(authenticatedUser.email, authenticatedUser.email + '-user')" />
                        </div>
                    </div>

                    <!-- MFA Enrollment -->
                    <div class="info-box">
                        <p><strong>MFA:</strong></p>
                        <div class="info-box-value">
                            <p [id]="mfaEnrollments + '-user'">{{ mfaEnrollments ?? "-" }}</p>
                        </div>
                    </div>

                    <div class="divider"></div>

                    <h4 class="info-header">Customer:</h4>

                    <!-- UID -->
                    <div class="info-box">
                        <p><strong>Owner UID:</strong></p>
                        <div class="info-box-value">
                            <p [id]="dashboardOwnerUser.uid">{{ dashboardOwnerUser.uid }}</p>
                            <img src="assets/icons/copy-icon.svg" class="info-box-value-copy" alt="copy" (click)="helperService.copySomeText(dashboardOwnerUser.uid, dashboardOwnerUser.uid)" />
                        </div>
                    </div>

                    <!-- Operator UID -->
                    <div class="info-box">
                        <p><strong>Operator UID:</strong></p>
                        <div class="info-box-value">
                            <p [id]="operatorUID()">{{ operatorUID() }}</p>
                            @if (operatorUID() !== "N/A") {
                                <img src="assets/icons/copy-icon.svg" class="info-box-value-copy" alt="copy" (click)="helperService.copySomeText(operatorUID(), operatorUID())" />
                            }
                        </div>
                    </div>

                    <!-- Email-->
                    <div class="info-box">
                        <p><strong>Email:</strong></p>
                        <div class="info-box-value">
                            <p [id]="controlledUser.email">{{ controlledUser.email }}</p>
                            <img src="assets/icons/copy-icon.svg" class="info-box-value-copy" alt="copy" (click)="helperService.copySomeText(controlledUser.email, controlledUser.email)" />
                        </div>
                    </div>

                    <!-- AccID-->
                    <div class="info-box">
                        <p><strong>AccID::</strong></p>
                        <div class="info-box-value">
                            <p [id]="controlledUser.account_id">{{ controlledUser.account_id }}</p>
                            <img src="assets/icons/copy-icon.svg" class="info-box-value-copy" alt="copy" (click)="helperService.copySomeText(controlledUser.account_id, controlledUser.account_id)" />
                        </div>
                    </div>
                    <!-- CustID-->
                    <div class="info-box">
                        <p><strong>CustID:</strong></p>
                        <div class="info-box-value">
                            <p [id]="controlledUser.billing?.stripe_customer_id">{{ controlledUser.billing?.stripe_customer_id ?? "N/A" }}</p>
                            @if (controlledUser.billing?.stripe_customer_id) {
                                <img src="assets/icons/copy-icon.svg" class="info-box-value-copy" alt="copy" (click)="helperService.copySomeText(controlledUser.billing.stripe_customer_id, controlledUser.billing.stripe_customer_id)" />
                            }
                        </div>
                    </div>
                    <!-- Economic-->
                    <div class="info-box">
                        <p><strong>Economic:</strong></p>
                        <div class="info-box-value">
                            <p [id]="controlledUser.billing?.economic_customer_number">{{ controlledUser.billing?.economic_customer_number ?? "N/A" }}</p>
                            @if (controlledUser.billing?.economic_customer_number) {
                                <img
                                    src="assets/icons/copy-icon.svg"
                                    class="info-box-value-copy"
                                    alt="copy"
                                    (click)="helperService.copySomeText(controlledUser.billing.economic_customer_number, controlledUser.billing.economic_customer_number)"
                                />
                            }
                        </div>
                    </div>
                    <!-- Located-->
                    <div class="info-box">
                        <p><strong>Located:</strong></p>
                        <div class="info-box-value">
                            <p [id]="regionCountry()">{{ regionCountry() }}</p>
                        </div>
                    </div>

                    <div class="divider"></div>

                    <!-- is operator-->
                    <div class="info-box-value">
                        <p><strong>Operator:</strong></p>
                        <p [id]="controlledUser.ownerClaims.operator">{{ controlledUser.ownerClaims.operator ?? false }}</p>
                    </div>
                    <!-- Billing interval-->
                    <div class="info-box-value">
                        <p><strong>Billing interval:</strong></p>
                        <p [id]="controlledUser.subscriptionPlanInterval">{{ controlledUser.subscriptionPlanInterval !== 0 ? controlledUser.subscriptionPlanInterval + " months" : "N/A" }}</p>
                    </div>
                    <!-- Price-->
                    <div class="info-box-value">
                        <p><strong>Price:</strong></p>
                        <p [id]="controlledUser.price">{{ controlledUser?.price ? helperService.getPrice(controlledUser.price) : "N/A" }}</p>
                    </div>
                    <!-- VAT Verified-->
                    <div class="info-box-value">
                        <p><strong>VAT Number:</strong></p>
                        <p [id]="controlledUser.vat_number">
                            <span>
                                {{ controlledUser.vat_number ?? "N/A" }}
                                @if (controlledUser.vat_number) {
                                    <img class="info-box-value-check" src="assets/icons/{{ controlledUser.vat_verified ? 'check-circle' : 'cross' }}.svg" alt="Check icon" />
                                }
                            </span>
                        </p>
                    </div>
                    <!-- Plan-->
                    <div class="info-box-value">
                        <p><strong>Plan:</strong></p>
                        <p [id]="controlledUser.subscriptionPlanType">{{ controlledUser.subscriptionPlanType }}</p>
                    </div>
                    <!-- Additional Access-->
                    @if (controlledUser.additionalAccess) {
                        <div class="info-box-value">
                            <p><strong>Additional:</strong></p>
                            <p [id]="controlledUser.additionalAccess">{{ controlledUser.additionalAccess ? "Yes" : "No" }}</p>
                        </div>
                    }
                    <!-- Exclude Access-->
                    @if (controlledUser.excludeAccess) {
                        <div class="info-box-value">
                            <p><strong>Exclude:</strong></p>
                            <p [id]="controlledUser.excludeAccess">{{ controlledUser.excludeAccess ? "Yes" : "No" }}</p>
                        </div>
                    }
                }
            </div>
        </section>
        <section class="end">
            <nav class="nav">
                <a role="button" class="nav-link" (click)="exitControlledState()">
                    <img src="assets/icons/nav-icons-black/log-out.svg" alt="log-out icon" />
                    <span>End session</span>
                </a>
            </nav>
        </section>
    </aside>
}
